import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

export interface Toast {
  id: string;
  message: string;
  subtitle?: string;
  type: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private readonly translate = inject(TranslateService);
  private toastsSubject = new BehaviorSubject<Toast[]>([]);
  public toasts$ = this.toastsSubject.asObservable();

  showActionRequired() {
    this.show(
      this.translate.instant('toast.actionRequired.title'),
      'warning',
      5000,
      this.translate.instant('toast.actionRequired.subtitle')
    );
  }

  show(message: string, type: Toast['type'] = 'info', duration = 3000, subtitle?: string) {
    const toast: Toast = {
      id: Date.now().toString(),
      message,
      subtitle,
      type,
      duration
    };

    const currentToasts = this.toastsSubject.value;
    this.toastsSubject.next([...currentToasts, toast]);

    if (duration > 0) {
      setTimeout(() => this.remove(toast.id), duration);
    }
  }

  remove(id: string) {
    const currentToasts = this.toastsSubject.value;
    this.toastsSubject.next(currentToasts.filter(toast => toast.id !== id));
  }
}